/* eslint-disable max-len */
import React, { SVGProps } from 'react';
import Icon from './Icon';

const Lock: React.FunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
  <Icon width="15px" height="16px" viewBox="0 0 15 16" {...props}>
    <path
      d="M12.8803489,15.9999952 C13.708472,15.9999952 14.3803454,15.3281218 14.3803454,14.4999988 L14.3803454,8.50001311 C14.3803454,7.67189009 13.708472,7.00001669 12.8803489,7.00001669 L12.1303507,7.00001669 L12.1303507,4.75002205 C12.1303507,2.1312844 9.99909969,3.33786011e-05 7.38036204,3.33786011e-05 C4.76162439,3.33786011e-05 2.63037336,2.1312844 2.63037336,4.75002205 L2.63037336,7.00001669 L1.88037873,7.00001669 C1.05225213,7.00001669 0.380378729,7.67189009 0.380378729,8.50001311 L0.380378729,14.4999988 C0.380378729,15.3281218 1.05225213,15.9999952 1.88037873,15.9999952 L12.8803489,15.9999952 Z M9.63035668,7.00001669 L5.1303674,7.00001669 L5.1303674,4.75002205 C5.1303674,3.50939391 6.13973389,2.50002742 7.38036204,2.50002742 C8.62099019,2.50002742 9.63035668,3.50939391 9.63035668,4.75002205 L9.63035668,7.00001669 Z"
      id="l"
    />
  </Icon>
);

export default Lock;
